import { Question, HandHeart } from "@phosphor-icons/react";
import { SectionShell } from "../../styleguide/Primitives";
import { Showcase } from "../LibraryPrimitives";
import {
  MultipleChoiceCard,
  ReadingPassageCard,
  HintCard,
  ExplanationCard,
  CelebrationCard,
} from "../questions";

export function QuestionsSection() {
  return (
    <SectionShell
      id="questions"
      eyebrow="Questions"
      eyebrowIcon={Question}
      title="The heart of Bloom"
      description="Questions are where learning happens — so they're warm, clear and confidence-building. Mistakes are met with a gentle nudge and another go, never a red cross of shame. Try the example below."
    >
      <div className="space-y-8">
        <div className="rounded-3xl border-2 border-primary/30 bg-primary/[0.04] p-5 md:p-6">
          <p className="mb-4 inline-flex items-center gap-2 rounded-full bg-primary/12 px-3 py-1.5 text-sm font-bold text-primary-strong">
            <HandHeart size={16} weight="fill" /> Interactive · pick an answer and press Check
          </p>
          <MultipleChoiceCard />
        </div>

        <div className="grid gap-5 lg:grid-cols-2">
          <Showcase title="Reading passage"><ReadingPassageCard /></Showcase>
          <div className="space-y-5">
            <Showcase title="Hint card"><HintCard /></Showcase>
            <Showcase title="Explanation"><ExplanationCard /></Showcase>
          </div>
        </div>

        <Showcase title="Celebration" description="Saved for genuine milestones — confetti only when it's truly earned" tone="muted">
          <div className="mx-auto max-w-md"><CelebrationCard /></div>
        </Showcase>
      </div>
    </SectionShell>
  );
}

export default QuestionsSection;
